import React from "react";
import "./style.scss";

import Buttom from "../../components/Buttom";
import Title from "../../components/Title";
import LayoutSteps from "../Shared/LayoutSteps";
import LogoIP from "./images/logo-ie.png";

import { ContextDefault } from "./../../context/Provider";

const Thankyou = () => {
  const context = React.useContext(ContextDefault);

  React.useEffect(() => {
    context.actions.setProgressBarVisiblity(false);
  }, [context.actions]);

  return (
    <LayoutSteps className="wrapper-fisica" renderButtom={props => <Buttom data-class="btn-donation--default" {...props} />}>
      <div className="container">
        <p>Operação realizada com sucesso.</p>
        <Title className="title--red">
          O Instituto Península agradece a <br /> sua contribuição
        </Title>
        <img src={LogoIP} alt="Insituto Peninsula" />
      </div>
    </LayoutSteps>
  );
};

export default Thankyou;
